import { useEffect, useReducer } from "react";
import { WmButton } from "@watermarkinsights/ripple-react";
import translate from "../../../i18n/translate";
import { downloadPDF } from "../../common/helper";
import { sendRequest, sendRequestWithPayload } from "../../../common/http";
import { useIntl } from "react-intl";

interface ExportResultSet {
  pdf_file_bytes: string;
}
interface TokenResultSet {
  token: string;
}
interface Action {
  type: string;
  token: string | null;
  data: boolean;
}

const defaultAction = {
  type: "",
  token: "",
  data: false
};

interface HeaderState {
  token: string | null;
  isExportInProgress: boolean;
}

const reducer = (state: HeaderState, action: Action) => {
  switch (action.type) {
    case "setToken":
      return { ...state, token: action.token };
    case "setExportInProgress":
      return { ...state, isExportInProgress: action.data };
    default:
      return state;
  }
};

const initialState: HeaderState = {
  token: null,
  isExportInProgress: false
};

export default function Header({
  showDownloadBtn
}: {
  showDownloadBtn: boolean;
}): JSX.Element {
  showDownloadBtn;
  const [state, dispatch] = useReducer(reducer, initialState);
  const header = useIntl().formatMessage({
    id: "app.ces.responseRate.courseEvaluationResponseRate"
  });
  const subHeader = useIntl().formatMessage({
    id: "app.ces.responseRate.drilldownSubHeading"
  });
  useEffect(() => {
    if (state.isExportInProgress) {
      sendRequest(
        {
          uri: "/export/token",
          camelize: true
        },
        (result: TokenResultSet) => {
          dispatch({
            ...defaultAction,
            type: "setToken",
            token: result.token
          });
        }
      );
    }
  }, [state.isExportInProgress]);
  useEffect(() => {
    if (state.token && state.isExportInProgress) {
      exportToPdf();
    }
  }, [state.isExportInProgress, state.token]);

  function exportToPdf() {
    let mainContent = document.querySelector('[data-export-id="ces-export"]');
    let downloadText = document.querySelector(".download-text");
    if (downloadText) {
      downloadText.setAttribute("tabindex", "0");
      (downloadText as HTMLElement).focus();
    }
    if (mainContent) {
      let clone = mainContent.cloneNode(true);

      let wrapperDiv = document.createElement("div");
      wrapperDiv.appendChild(clone);

      let formData = new FormData();
      formData.append("html", wrapperDiv.outerHTML);
      formData.append("header", encodeURIComponent(header));
      formData.append("sub_header",  encodeURIComponent(subHeader));
      formData.append("export_id", "response-rate-export")
      formData.append("_csrf_token", state.token ? state.token : "");

      const applyResult = (result: ExportResultSet) => {
        downloadPDF(result.pdf_file_bytes, "Course_Evaluation_Insights");
        dispatch({ ...defaultAction, type: "setToken", token: null });
        dispatch({
          ...defaultAction,
          type: "setExportInProgress",
          data: false
        });
      };
      const onError = (error: string) => {
        // Log error in console for debugging
        console.log("API Error:", error);
        dispatch({ ...defaultAction, type: "setToken", token: null });
        dispatch({
          ...defaultAction,
          type: "setExportInProgress",
          data: false
        });
      };
      sendRequestWithPayload(
        {
          uri: "/export",
          body: formData
        },
        applyResult,
        onError
      );
    }
  }
  return (
    <section
      className="page-banner-container -mainheader -withbreadcrumbs only-breadcrumbs header-padding"
      id="page-header"
    >
      <div className="flex-row export-container">
        <div>
          <div>
            <span className="org-name uppercase">{header}</span>
          </div>
          <div className="identity-details">
            <div className="page-header -titleonly">
              <h2 id="main-heading" className="plan-title-header">{subHeader}</h2>
            </div>
          </div>
        </div>
        {showDownloadBtn && (
          <div className="flex-row export-button">
            {state.isExportInProgress && (
              <span className="download-text">
                {translate(
                  "app.planParticipation.exportPdf.downloadReportText"
                )}
              </span>
            )}
            <div className="button-container">
              <WmButton
                button-type="secondary"
                icon="f1da"
                icon-size="20px"
                onClick={() =>
                  dispatch({
                    ...defaultAction,
                    type: "setExportInProgress",
                    data: true
                  })
                }
                disabled={state.isExportInProgress}
              >
                {translate("app.downloadHtml")}
              </WmButton>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
